export default __webpack_public_path__ + "static/media/Logo Group.41954a3b.png";